import React from 'react';
import { ObjectList } from '../../queries/ObjectList';
import Button from '../Button';

export default function Pager<T>({
    objectList,
    skip,
    pageSize,
    onNextPage,
    onPreviousPage,
}: {
    objectList: ObjectList<T>;
    skip: number;
    pageSize: number;
    onNextPage?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onPreviousPage?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) {
    return (
        <div className="flex flex-row-reverse items-center gap-3 mt-4">
            {Math.ceil(objectList.totalCount / pageSize) -
                Math.ceil((objectList.totalCount - skip) / pageSize) <
                Math.ceil(objectList.totalCount / pageSize) - 1 && (
                <Button secondary onClick={onNextPage}>
                    Next
                </Button>
            )}
            {Math.ceil(objectList.totalCount / pageSize) -
                Math.ceil((objectList.totalCount - skip) / pageSize) >
                0 && (
                <Button secondary onClick={onPreviousPage}>
                    Back
                </Button>
            )}
            <div className="text-sm text-foreground-secondary">
                {1 +
                    (Math.ceil(objectList.totalCount / pageSize) -
                        Math.ceil((objectList.totalCount - skip) / pageSize))}
                /{Math.ceil(objectList.totalCount / pageSize)}
            </div>
        </div>
    );
}
